function showImportInventoryField(value) {
  if (value === 'links') {
    $('.rewards_inventory_div').show();
  }
  else {
    $('.rewards_inventory_div').hide();
  }
}

$(document).ready(function(){
  const reward_type_value = $("input[type=radio][name='reward[reward_type]']:checked").val()
  if (reward_type_value === 'links') {
    showImportInventoryField(reward_type_value);
  }
  else {
    $('.rewards_inventory_div').hide();
  }

  $("input[type=radio][name='reward[reward_type]']").change(function() {
    showImportInventoryField(this.value);
  });
});
